export default __webpack_public_path__ + "static/media/online-classroom.83a7790d.png";